import PeluangRAE from './PeluangRAE'

export default PeluangRAE